import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ScrollUtil from 'utils/ScrollUtil';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    ScrollUtil.scrollToTop();
  }, [pathname]);

  return null;
}
